export default __webpack_public_path__ + "static/mobile_sek2_KV06-c0da9d688630302e308868d0fdebc590.mp4";